module.exports = __webpack_public_path__ + "img/3.0f3a4a4b.png";